// extracted by mini-css-extract-plugin
module.exports = {"logo":"OAuthPage_logo__vCODx","formContainer":"OAuthPage_formContainer__2cjop"};